import React from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon';

// Note: fa class is from kangarootime-ui's Button
const IconToolbar = ({ icons }) => (
  <div className='flex-rows' style={{ justifyContent: 'flex-end', alignItems: 'center' }}>
    { icons.map((icon, index) => (
      <Icon
        key={index}
        icon={icon.faIcon}
        tooltip={icon.tooltip}
        onClick={icon.onClick}
      />
    ))}
  </div>
);

IconToolbar.propTypes = {
  icons: PropTypes.arrayOf(PropTypes.shape({
    faIcon: PropTypes.string,
    tooltip: PropTypes.string,
    onClick: PropTypes.func
  }))
};

export default IconToolbar;
